import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import './App.css';

// Components
import Header from './components/Header';
import HomePage from './pages/HomePage';
import AdminDashboard from './pages/AdminDashboard';
import Footer from './components/Footer';
// FixStats removed per user request

// Context
import { DonationProvider } from './contexts/DonationContext';
import { ModalProvider } from './contexts/ModalContext';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--light-bg);
`;

const MainContent = styled.main`
  flex: 1 0 auto;
  padding-top: 70px;
`;

function App() {
  return (
    <DonationProvider>
      <ModalProvider>
        <Router>
          <AppContainer>
            <Header />
            <MainContent>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
            </MainContent>
            <Footer />
          </AppContainer>
        </Router>
      </ModalProvider>
    </DonationProvider>
  );
}

export default App;
